export default {
    H1: 0.90,
    H2: 0.90,
    H3: 0.90,
    M4: 0.81,
    M5: 0.81,
    M6: 0.81,
    L7: 0.72,
    L8: 0.72,
    L9: 0.72,
    L10: 0.68,
    SC: 0.90,
    WR: 0.90,
    WR_FS: 0.90
}
